export const emailRegex =
  // eslint-disable-next-line no-useless-escape,no-control-regex
  /^(?!\.)(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)](?<!\.)$/;

// Letters only, no numbers. No emojis. Special characters limited to space and hyphen.
export const lettersOnlyWithSpaceAndHyphenRegex = /^[a-zA-Zа-яА-Я\s-]+$/;

// Letters, numbers, and all special characters allowed. No emojis.
export const lettersNumbersAndSpecialsRegex =
  /^[a-zA-Zа-яА-Я0-9\s.,!?"'@#$%^&*()_+\-=[\]{};:<>\\|/~`]+$/;

// Digits only (0-9)
export const digitsOnlyRegex = /^\d*$/;

// Non-digits (all characters except 0-9)
export const nonDigitRegex = /\D+/g;
